var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreaSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.278,
    height: 14.278,
    viewBox: "0 0 14.278 14.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.462 8.031H2.9a.223.223 0 0 1-.223-.223v-.446a.223.223 0 0 1 .223-.223h1.562V5.354H2.9a.223.223 0 0 1-.223-.223v-.446a.223.223 0 0 1 .223-.223h1.562V2.677H2.9a.223.223 0 0 1-.223-.223v-.446a.223.223 0 0 1 .223-.223h1.562V.892A.892.892 0 0 0 3.569 0H.892A.892.892 0 0 0 0 .892v12.494a.859.859 0 0 0 .044.217l4.418-4.418zm8.924 1.785h-.892v1.562a.223.223 0 0 1-.223.223h-.446a.223.223 0 0 1-.223-.223V9.816H9.816v1.562a.223.223 0 0 1-.223.223h-.446a.223.223 0 0 1-.223-.223V9.816H7.139v1.562a.223.223 0 0 1-.223.223H6.47a.223.223 0 0 1-.223-.223V9.816H5.093L.675 14.234a.857.857 0 0 0 .218.044h12.493a.892.892 0 0 0 .892-.892v-2.678a.892.892 0 0 0-.892-.892z",
    style: {
      fill: "#9e9e9e"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaSocial);
export default __webpack_public_path__ + "static/media/area-social.a8f31e6ec3b06013bbb547263f918fea.svg";
export { ForwardRef as ReactComponent };